export default function (data) {
  var base64data = btoa(JSON.stringify(data));
  sessionStorage.setItem('ipgeo', base64data);
}
